<template>
  <div class="card">
    <div class="card-header">
      <h6>Crear Leads</h6>
    </div>
    <div class="card-body px-4">
      <div class="row">
        <div class="col">
          <label>Nombres</label>
          <input type="text" class="form-control" v-model="form.name" />
          <label>Correo</label>
          <input type="text" class="form-control" v-model="form.email" />
          <label>Identificación</label>
          <input
            type="text"
            class="form-control"
            v-model="form.identification"
          />
          <label>Teléfono</label>
          <input type="text" class="form-control" v-model="form.phone" />
          <label>País</label>
          <input type="text" class="form-control" v-model="form.country" />
          <label>Campaña</label>
          <input type="text" class="form-control" v-model="form.campaign" />
          <label>Contraseña</label>
          <input type="text" class="form-control" v-model="form.password" />
          <button class="btn bg-gradient-success w-100 mt-4" @click="create">
            Crear nuevo lead
          </button>
        </div>
        <div class="col">
          <h6>Importar usuario de otra plataforma</h6>
          <input
            type="text"
            class="form-control"
            placeholder="Ingrese ID de usuario"
            v-model="user_id_import"
          />
          <div v-if="isLoading" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
            <p class="mt-2">Cargando información del usuario...</p>
          </div>
          <div v-else>
            <table
              class="table table-bordered table-sm mt-2"
              v-if="user_info_import.user"
            >
              <tbody>
                <tr>
                  <td>Nombre y Correo</td>
                  <td>
                    {{ user_info_import.user.name }}
                  </td>
                  <td>
                    {{ user_info_import.user.email }}
                  </td>
                </tr>
                <tr>
                  <td>País e Identificación</td>
                  <td>
                    {{ user_info_import.user.country }}
                  </td>
                  <td>
                    {{ user_info_import.user.identification }}
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              v-if="user_info_import.transaction"
              class="mt-3 card p-3 bg-light"
            >
              <h6 class="mb-2">Resumen de Transacciones</h6>
              <div class="d-flex justify-content-between">
                <div>
                  <strong>Total Transacciones:</strong>
                  <span class="badge bg-info ms-1">{{
                    user_info_import.transaction.total_transactions
                  }}</span>
                </div>
                <div>
                  <strong>Monto Total:</strong>
                  <span class="badge bg-success ms-1">{{
                    user_info_import.transaction.total_amount
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <button
            class="btn btn-primary w-100 mt-2"
            @click="getInformationFromAnotherPlatform"
            :disabled="isLoading"
          >
            <span v-if="isLoading">
              <i class="fas fa-spinner fa-spin me-1"></i> Cargando...
            </span>
            <span v-else>Obtener información del usuario de la plataforma</span>
          </button>
          <button
            class="btn btn-primary w-100"
            @click="importUserFromAnotherPlatform"
          >
            Importar información del usuario
          </button>
          <!-- <hr class="mt-2 mb-4" />
          <h6>Importar usuario desde Excel</h6>
          <label class="mt-4"
            >Seleccione el archivo que desea importar <br /><span class="text-danger"
              >Este proceso puede tardar unos minutos dependiendo de la cantidad de
              información.</span
            ></label
          >
          <form
            class="d-flex justify-content-around"
            enctype="multipart/form-data"
            @submit.prevent="importLeads"
          >
            <div class="w-100">
              <input
                id="myFile"
                ref="file"
                class=""
                type="file"
                @change="onSelect($event)"
              />
              <a
                href="https://recoverydocs.s3.us-west-1.amazonaws.com/FORMATO%2BIMPORTAR%2BLEADS.xlsx"
                target="_blank"
                class="btn btn-danger w-100 mt-4"
              >
                Descargar Excel</a
              >
              <button type="submit" class="btn btn-danger w-100">
                Importar Excel
              </button>
            </div>
          </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "@/utils/httpRequest";
import uploadFile from "@/utils/uploadFile";
import axios from "axios";
export default {
  name: "index",
  data: () => ({
    file: "",
    form: {
      name: "",
      email: "",
      phone: "",
      identification: "",
      password: "",
      type: "leads",
      country: "",
      campaign: "",
    },
    user_id_import: "",
    user_info_import: {
      user: null,
      transactions: [],
      transaction: null,
      bank: null,
    },
    isLoading: false,
  }),
  methods: {
    async create() {
      if (
        this.form.name !== "" &&
        this.form.email !== "" &&
        this.form.phone !== "" &&
        this.form.identification !== "" &&
        this.form.password !== "" &&
        this.form.campaign !== "" &&
        this.form.country !== ""
      ) {
        const { data } = await post("users/create-leads", this.form, true);
        if (data === 200) {
          this.$swal({
            html: "Procesado con éxito",
            icon: "success",
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.form = {
            name: "",
            email: "",
            phone: "",
            identification: "",
            password: "",
            type: "agent",
          };
        }
      }
    },
    async importLeads() {
      if (this.file !== undefined && this.file !== "") {
        await uploadFile.upload("users/upload-excel", { file: this.file });
        this.$swal({
          html:
            "Procesado con éxito. <br> Este proceso puede tardar unos minutos según la cantidad de información.",
          icon: "success",
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
        window.location.reload();
      }
    },
    resetInputFile(e) {
      e.target.value = "";
    },
    onSelect(e) {
      this.file = e.target.files[0];
    },
    async getInformationFromAnotherPlatform() {
      if (this.user_id_import.length > 10) {
        try {
          this.isLoading = true;
          const { data } = await axios.get(
            process.env.VUE_APP_PLATFORM_IMPORT +
              `auth/export-information-by-user-id?id=${this.user_id_import}`
          );
          this.user_info_import = data;
        } catch (error) {
          console.error("Error fetching user information:", error);
          this.$swal({
            html: "Error al obtener información del usuario",
            icon: "error",
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        } finally {
          this.isLoading = false;
        }
      }
    },
    async importUserFromAnotherPlatform() {
      if (
        this.user_info_import.user &&
        Object.keys(this.user_info_import.user).length > 0
      ) {
        try {
          this.isLoading = true;
          await post(
            `users/import-user-from-another-platform`,
            this.user_info_import
          );
          this.user_info_import = {
            user: null,
            transactions: [],
            transaction: null,
            bank: null,
          };
          this.user_id_import = "";
          this.$swal({
            html: "Proceso completado exitosamente",
            icon: "success",
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        } catch (error) {
          console.error("Error importando usuario:", error);
          this.$swal({
            html: "Error al importar el usuario",
            icon: "error",
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        } finally {
          this.isLoading = false;
        }
      } else {
        this.$swal({
          html: "No hay información de usuario para importar",
          icon: "warning",
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
  },
};
</script>

<style scoped></style>
